import { render, staticRenderFns } from "./TheCartComponentPickup.vue?vue&type=template&id=4add10b0&"
import script from "./TheCartComponentPickup.vue?vue&type=script&lang=js&"
export * from "./TheCartComponentPickup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports